<template>
  <div class="register">
    <h1 class="top">Bodor+3.0 {{ $t("information.new") }}</h1>
    <div class="regbox">
      <!-- <div class="back" @click="back">{{ $t("register.back") }}</div> -->
      <h3>{{ $t("information.title") }}</h3>
      <a-form
        class="inputbox"
        ref="formRef"
        :model="formState"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-item :label="$t('information.people')" name="people">
          <a-input
            v-model:value="formState.people"
            :placeholder="$t('information.peoplein')"
            :disabled="peopleDis"
          />
        </a-form-item>
        <a-form-item :label="$t('register.phone')" name="phone">
          <a-input
            v-model:value="formState.phone"
            :placeholder="$t('register.phonein')"
            :disabled="phoneDis"
          />
        </a-form-item>
        <a-form-item :label="$t('register.email')" name="email">
          <a-input
            v-model:value="formState.email"
            :placeholder="$t('register.emailin')"
            :disabled="emailDis"
          />
        </a-form-item>
        <a-form-item :label="$t('information.company')" name="company">
          <a-input
            v-model:value="formState.company"
            :placeholder="$t('information.companyin')"
            :disabled="companyDis"
          />
        </a-form-item>
        <a-form-item :label="$t('information.address')" name="address">
          <a-input
            v-model:value="formState.address"
            :placeholder="$t('information.addressin')"
            :disabled="addressDis"
          />
        </a-form-item>
      </a-form>

      <a-button type="primary" class="regbtn" @click="register" :loading="btnLoading">
        {{ registerBtn }}</a-button
      >
    </div>
  </div>
</template>
<script setup>
import {
  ref,
  onMounted,
  onUnmounted,
  watch,
  computed,
  defineComponent,
  reactive,
  toRaw,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";
import { Modal } from "ant-design-vue";
import { h } from "vue";
import { useI18n } from "vue-i18n";
const i18n = useI18n();

let router = useRouter();

const { t } = useI18n();
const isCam = ref(false);
const isChina = ref(localStorage.getItem("lang") == "zh");
const peopleDis = ref(false);
const phoneDis = ref(false);
const emailDis = ref(false);
const companyDis = ref(false);
const addressDis = ref(false);
const btnLoading = ref(false);
const object = ref({});

const formState = ref({
  people: undefined,
  phone: undefined,
  email: undefined,
  company: undefined,
  address: undefined,
});
//清空输入框是弹出提示
let rules = {
  people: [
    {
      required: true,
      message: t("information.peopleEmpty"),
      trigger: "change",
    },
  ],
  phone: [
    {
      required: true,
      message: t("register.phoneEmpty"),
      trigger: "change",
    },
  ],
  email: [
    {
      required: true,
      message: t("register.emailEmpty"),
      trigger: "change",
    },
  ],
  company: [
    {
      required: true,
      message: t("information.companyEmpty"),
      trigger: "change",
    },
  ],
  address: [
    {
      required: true,
      message: t("information.addressEmpty"),
      trigger: "change",
    },
  ],
};

const emailVer = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const phoneVer = /^(\+|\d{1,3})\s?(\d{1,4})?\s?\(?\d{1,4}\)?\s?\d{1,4}\s?\-?\d{1,9}$/;
//点击提交按钮
const register = () => {
  if (!formState.value.people) {
    message.error(t("information.peopleEmpty"));
    return;
  } else if (!formState.value.phone) {
    message.error(t("register.phoneEmpty"));
    return;
  } else if (formState.value.phone && !formState.value.phone.match(phoneVer)) {
    message.error(t("register.phoneError"));
    return;
  } else if (!formState.value.email) {
    message.error(t("information.emailEmpty"));
    return;
  } else if (formState.value.email && !formState.value.email.match(emailVer)) {
    message.error(t("information.emailError"));
    return;
  } else if (!formState.value.company) {
    message.error(t("information.companyEmpty"));
    return;
  } else if (!formState.value.address) {
    message.error(t("information.addressEmpty"));
    return;
  } else {
    //提交接口
    SubmitEvent();
  }
};
function SubmitEvent() {
  btnLoading.value = true;
  console.log("sdfsdfsd");
  object.value = {
    UserName: formState.value.people,
    Phone: formState.value.phone,
    Email: formState.value.email,
    CompanyName: formState.value.company,
    Address: formState.value.address,
  };
  console.log(object.value);
  axios.post("api/Cam/SaveCamCustomer", object.value).then(function (response) {
    btnLoading.value = false;
    console.log(response);
    if (response.data.code == 200) {
      message.success("提交成功");
      //   setTimeout(function () {
      //     router.push("/login");
      //   }, 1000);
    } else {
      message.error(response.data.info);
    }
  });
}
const registerBtn = computed(() => {
  return t("information.register");
});
</script>
<style scoped>
.register {
  width: 100%;
  height: 100vh;
  color: black;
  position: relative;
  background: #ffffff url("@/assets/img/register.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}
.top {
  color: white;
  position: absolute;
  top: 10%; /* 垂直居中 */
  right: 50%;
  transform: translate(50%, 10%); /* 移动中心点位置 */
  margin: 0px;
}
.regbox {
  width: 500px;
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 50%; /* 垂直居中 */
  left: 50%;
  transform: translate(-50%, -50%); /* 移动中心点位置 */
  border-radius: 10px;
  overflow-y: visible;
  -moz-box-shadow: 5px 5px 30px black;
  -webkit-box-shadow: 5px 5px 30px black;
  box-shadow: 5px 5px 30px black;
  display: flex;
  flex-direction: column;
  align-items: center;
}
h1,
h2,
h3 {
  text-align: center;
  margin: 30px;
}
h3 {
  font-size: 24px;
}
.inputbox {
  width: 80%;
}
.codebox {
  width: 80%;
  display: flex;
  justify-content: space-between;
}
.codebox input {
  width: 50%;
}
.ant-form-item {
  margin-bottom: 18px;
}
/*input {
  width: 100%;
  height: 40px;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  padding: 6px 12px;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  font-size: 14px;
  line-height: 1.42857143;
  box-sizing: border-box;
  outline: none;
  margin-bottom: 25px;
}
input:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  border: 1px solid rgba(81, 203, 238, 1);
}*/
.regbtn {
  width: 80%;
  height: 40px;
  border-radius: 1px;
  background-color: rgba(28, 132, 198, 1);
  cursor: pointer;
  text-align: center;
  color: white;
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 30px;
}
.disabledbtn {
  background-color: gray;
  cursor: not-allowed;
  display: inline-block;
  border-radius: 4px;
  border: none;
  color: #ffffff;
  text-align: center;
  width: 100%;
  height: 32px;
  line-height: 32px;
}
.codebtn {
  display: inline-block;
  border-radius: 4px;
  background-color: #3d405b;
  border: none;
  color: #ffffff;
  text-align: center;
  width: 100%;
  height: 32px;
  line-height: 32px;
  transition: all 0.5s;
  cursor: pointer;
}

.codebtn span {
  cursor: pointer;
  display: inline-block;
  position: relative;
  transition: 0.5s;
}

.codebtn span:after {
  content: "»";
  position: absolute;
  opacity: 0;
  top: 0;
  right: -15px;
  transition: 0.5s;
}

.codebtn:hover span {
  padding-right: 15px;
}

.codebtn:hover span:after {
  opacity: 1;
  right: 0;
}

.error {
  position: absolute;
  bottom: 90px;
  text-align: left;
  width: 80%;
  color: red;
}

.back {
  position: absolute;
  left: 20px;
  top: 20px;
  color: #0099ff;
  font-size: 16px;
  cursor: pointer;
}
</style>
